export default "__VITE_ASSET__D__C$8fR__"